import { apiRequest } from "../../services/apiService";
import {
    ADD_SETTING_FAIL,
    ADD_SETTING_REQUEST,
    ADD_SETTING_SUCCESS,
    DELETE_SETTING_FAIL,
    DELETE_SETTING_REQUEST,
    DELETE_SETTING_SUCCESS,
    EDIT_SETTING_FAIL,
    EDIT_SETTING_REQUEST,
    EDIT_SETTING_SUCCESS,
    GET_MODULE_FAIL,
    GET_MODULE_REQUEST,
    GET_MODULE_SUCCESS,
    GET_SETTING_FAIL,
    GET_SETTING_LIST_DATA_FAIL,
    GET_SETTING_LIST_DATA_REQUEST,
    GET_SETTING_LIST_DATA_SUCCESS,
    GET_SETTING_REQUEST,
    GET_SETTING_SUCCESS,
  } from "../constant";

  export const getSettingList = (data) => {
    return async (dispatch) => {
      dispatch({ type: GET_SETTING_REQUEST });
      const { response, error } = await apiRequest({
        method: "POST",
        url: `/settings/getSettingList`,
        data : data
      });
      if (response) {
        dispatch({ type: GET_SETTING_SUCCESS, payload: response?.data });
        dispatch({ type: GET_SETTING_LIST_DATA_REQUEST, payload: response?.data });
        if (response?.data?.data) {
          const rawData = response?.data?.data;
          dispatch({
            type: GET_SETTING_LIST_DATA_SUCCESS,
            payload: rawData,
          });
        }
      } else if (error) {
        dispatch({ type: GET_SETTING_FAIL });
      }
    };
  };
  export const addSetting = (data) => {
    return async (dispatch) => {
        dispatch({ type: ADD_SETTING_REQUEST });
        const { response, error } = await apiRequest({
            method: 'POST',
            url: `/settings/addSetting  `,
            data: data
        })
        if (response) {
            dispatch({ type: ADD_SETTING_SUCCESS, payload: { id: response.data?.data?.insertId, data } })
        }
        else if (error) {
            dispatch({ type: ADD_SETTING_FAIL })
        }
    }
}